import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Radar } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { GoogleSignInButton } from "@/components/GoogleSignInButton";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@sidelineiq.com");
  const [password, setPassword] = useState("Admin123!");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      navigate("/feed");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#080B11] sq-grid-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#0F1420] border border-[#232D42] rounded-2xl p-8 shadow-2xl sq-fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-6">
          <div className="h-9 w-9 rounded-lg bg-[#00E5A3] flex items-center justify-center"><Radar size={20} className="text-[#04140F]" /></div>
          <span className="font-heading font-extrabold text-xl text-slate-100">Sideline<span className="text-[#00E5A3]">IQ</span></span>
        </Link>
        <h1 className="font-heading text-2xl font-bold text-slate-100 text-center">Welcome back</h1>
        <p className="text-sm text-slate-400 text-center mt-1 mb-6">Sign in to track player status & alerts</p>

        {error && <div data-testid="login-error" className="mb-4 rounded-lg bg-[#FF4D4D]/10 border border-[#FF4D4D]/30 px-3 py-2 text-sm text-[#FF7A7A]">{error}</div>}

        <GoogleSignInButton />
        <div className="flex items-center gap-3 my-5">
          <div className="h-px flex-1 bg-[#232D42]" />
          <span className="text-xs text-slate-600 font-mono">or</span>
          <div className="h-px flex-1 bg-[#232D42]" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-slate-300">Email</Label>
            <Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 bg-[#151B2B] border-[#232D42] text-slate-100" required />
          </div>
          <div>
            <Label className="text-slate-300">Password</Label>
            <Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 bg-[#151B2B] border-[#232D42] text-slate-100" required />
          </div>
          <Button data-testid="login-submit-btn" type="submit" disabled={loading}
            className="w-full bg-[#00E5A3] hover:bg-[#00C98E] text-[#04140F] font-semibold h-11">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
        <p className="text-sm text-slate-400 text-center mt-5">
          No account? <Link data-testid="go-register-link" to="/register" className="text-[#00E5A3] hover:underline">Create one</Link>
        </p>
        <p className="text-[11px] text-slate-600 text-center mt-3 font-mono">Demo admin prefilled · Pro tier</p>
      </div>
    </div>
  );
}
